import Head from 'next/head';
import { DefaultSeo } from 'next-seo';

export default function StructuredData() {
  return (
    <>
      <DefaultSeo
      // Define default SEO configuration here
      />
      <Head>
        <title>
          eighteen yards | sports digital marketing data & analytics
        </title>
        <meta
          name="description"
          content="Empower your business with data-driven insights and detailed reporting through our Data and Analytics services. Contact our team today."
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "url": "https://eighteenyards.com/services/data-analytics",
              "name": "eighteen yards | sports digital marketing data & analytics",
              "description": "Empower your business with data-driven insights and detailed reporting through our Data and Analytics services. Contact our team today.",
              "mainEntity": {
                "@type": "Service",
                "serviceType": "Data & Analytics",
                "provider": {
                  "@type": "Organization",
                  "name": "eighteen yards",
                  "url": "https://eighteenyards.com"
                },
                "description": "We're here to empower your business with data and analytics services that provide the insights you need to make informed decisions.",
                "hasOfferCatalog": {
                  "@type": "OfferCatalog",
                  "name": " Sports Digital Marketing",
                  "itemListElement": [
                    {
                      "@type": "Offer",
                      "itemOffered": {
                        "@type": "Service",
                        "name": "Data & Analytics",
                        "description": "Our Data and Analytics services cover a range of essential areas, including but not limited to Google Analytics, Google Tag Manager, and Reporting."
                      }
                    }        
                  ]
                }
              }
            }
            ),
          }}
        />
      </Head>
    </>
  )
}
